"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

// .modal-open      - body class for killing the scroll
// .modal           - container to scroll within
// .modal-dialog    - positioning shell for the actual modal
// .modal-content   - actual modal w/ bg and corners and stuff
var gridBreakpoints = {
  xs: 0,
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px'
};
var $zindexModal = 1050;
var $modalDialogMargin = '10px';
var $modalContentBg = '#fff';
var $modalContentBorderWidth = '0px';
var $borderRadiusLg = '3px';
var $modalContentBoxShadowXs = '0 5px 15px rgba(0,0,0,.5)';
var $modalContentBorderColor = '#fff';
var $zindexModalBackdrop = 1040;
var $modalBackdropBg = '#000';
var $modalBackdropOpacity = '0.1';
var $modalHeaderPadding = '15px';
var $modalHeaderBorderWidth = '1px';
var $modalHeaderBorderColor = '#e5e5e5';
var $modalTitleLineHeight = '1.42';
var $modalInnerPadding = '15px';
var $modalFooterBorderWidth = '1px';
var $modalFooterBorderColor = '#e5e5e5';
var $modalSm = '300px';
var $modalMd = '500px';
var $modalDialogMarginYSmUp = '30px';

var makeStyle = function makeStyle() {
  return {
    '@global .sr-only': {
      position: 'absolute',
      width: '1px',
      height: '1px',
      padding: '0',
      margin: ' -1px',
      overflow: 'hidden',
      clip: 'rect(0,0,0,0)',
      border: 0
    },
    '@global .modal-backdrop': {
      position: 'fixed',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      zIndex: 1040,
      backgroundColor: '#000'
    },
    '@global .modal-backdrop.in': {
      filter: 'alpha(opacity=50)',
      opacity: '.5'
    },
    '@global .modal-backdrop.fade': {
      filter: 'alpha(opacity=0.3)',
      opacity: '0.3'
    },
    stiloModal: (0, _defineProperty2["default"])({
      '&.modal.fade': {
        top: 0,
        // need to override the .modal.fade { top: 45%; } from EV2's bootstrap CORE-6558
        opacity: 0,
        transition: 'opacity .15s linear',
        transform: 'translate(0,-5%)'
      },
      '&.modal.fade.in': {
        top: 0,
        opacity: 1,
        transition: 'transform .3s ease-out',
        transform: 'translate(0, 0)'
      },
      '& .modal-open': {
        overflow: 'hidden'
      },
      '&.modal': {
        margin: 0,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        position: 'fixed',
        width: '100%',
        zIndex: $zindexModal,
        display: 'none',
        overflow: 'hidden',
        outline: 0,
        background: 'none',
        backgroundColor: 'none',
        border: 'none',
        boxShadow: 'none',
        '&.modal-dialog': {
          transform: 'translate(0, -25%)'
        }
      },
      '& .modal-open .modal': {
        overflowX: 'hidden',
        overflowY: 'auto'
      },
      // Shell div to position the modal with bottom padding
      '& .modal-dialog': {
        position: 'relative',
        width: 'auto',
        margin: $modalDialogMargin
      },
      // Actual modal
      '& .modal-content': {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: $modalContentBg,
        backgroundClip: 'padding-box',
        border: "".concat($modalContentBorderWidth, " solid ").concat($modalContentBorderColor),
        borderRadius: $borderRadiusLg,
        boxShadow: $modalContentBoxShadowXs,
        outline: 0
      },
      '& .modal-backdrop': {
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        zIndex: $zindexModalBackdrop,
        backgroundColor: $modalBackdropBg,
        // Fade for backdrop
        '& .fade': {
          opacity: 0
        },
        '& .show': {
          opacity: $modalBackdropOpacity
        }
      },
      '& .modal-header': {
        display: 'flex',
        flexDirection: 'row-reverse',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: $modalHeaderPadding,
        borderBottom: "".concat($modalHeaderBorderWidth, " solid ").concat($modalHeaderBorderColor),
        backgroundImage: 'none',
        background: 'none',
        '& .close': {
          marginLeft: 'auto',
          marginTop: '-2px'
        }
      },
      '& .modal-title': {
        margin: 0,
        lineHeight: $modalTitleLineHeight
      },
      // Modal body
      // Where all modal content resides (sibling of .modal-header and .modal-footer)
      '& .modal-body': {
        position: ' relative',
        // Enable `flex-grow: 1` so that the body take up as much space as possible
        // when should there be a fixed height on `.modal-dialog`.
        flex: '1 1 auto',
        padding: $modalInnerPadding
      },
      // Footer (for actions)
      '& .modal-footer': {
        display: 'flex',
        alignItems: 'center',
        // vertically center
        justifyContent: 'flex-end',
        // Right align buttons with flex property because text-align doesn't work on flex items
        padding: $modalInnerPadding,
        borderTop: "".concat($modalFooterBorderWidth, " solid ").concat($modalFooterBorderColor),
        // Easily place margin between footer elements
        '& > :not(:first-child)': {
          marginLeft: '.25rem'
        },
        '& > :not(:last-child)': {
          marginTight: '.25rem'
        }
      },
      // Measure scrollbar width for padding body during modal show/hide
      '& .modal-scrollbar-measure': {
        position: 'absolute',
        top: '-9999px',
        width: '50px',
        height: '50px',
        overflow: 'scroll'
      }
    }, "@media (min-width: ".concat(gridBreakpoints['sm'], ")"), {
      // Automatically set modal's width for larger viewports
      '& .modal-dialog': {
        maxWidth: $modalMd,
        margin: "".concat($modalDialogMarginYSmUp, " auto !important")
      },
      '& .modal-sm': {
        maxWidth: $modalSm
      }
    })
  };
};

var _default = makeStyle;
/*

               '& .modal-content': {
                    @include box-shadow($modal-content-box-shadow-sm-up);
                },

@include media-breakpoint-up(lg) {
  .modal-lg { max-width: $modal-lg; }
}

*/

exports["default"] = _default;
//# sourceMappingURL=style.js.map